import React from 'react'
import Background from "../Images/Programming.png"

const Services = [
    { name: 'Game Development', href: '#game' },
    { name: 'App Development', href: '#app' },
    { name: 'Web Development', href: '#web' },
    { name: 'AR/VR', href:  '#vr'}
]

function Hero() {
  return (
    <div className='relative isolate overflow-hidden py-20 lg:py-28 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900'>
        <div className='absolute inset-0 bg-gradient-to-r from-slate-900/90 to-slate-800/80'></div>
        <img
            src={Background}
            className='absolute inset-0 -z-10 h-full w-full object-cover opacity-15'
        />
        
        <div className='relative max-w-7xl mx-auto px-6 lg:px-8'>
            <div className='text-center'>
                <h1 className='hero-title mb-6 max-w-4xl mx-auto'>
                    Creating Digital Presence for Small Businesses
                </h1>
                <p className='text-lg md:text-xl text-slate-300 mb-10 max-w-2xl mx-auto leading-relaxed'>
                    Professional web development, mobile apps, and digital solutions 
                    tailored to help your business thrive in the digital world.
                </p>
                
                <div className='flex flex-col sm:flex-row gap-4 justify-center mb-16'>
                    <a href="#services" className='btn-primary inline-flex items-center justify-center'>
                        View Our Services
                        <svg className='ml-2 w-4 h-4' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 9l-7 7-7-7' />
                        </svg>
                    </a>
                    <a href="/contact" className='btn-secondary inline-flex items-center justify-center'>
                        Get Started Today
                    </a>
                </div>
            </div>
            
            <div className='hidden lg:flex flex-wrap justify-center gap-4 mt-12'>
                {Services.map((item) => (
                    <a
                        key={item.name}
                        href={item.href}
                        className='group relative bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-6 py-3 text-sm font-medium text-white hover:bg-white/20 transition-all duration-200 hover:scale-105'
                    >
                        <span className='relative z-10'>{item.name}</span>
                        <div className='absolute inset-0 rounded-full bg-gradient-to-r from-blue-500/20 to-purple-500/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200'></div>
                    </a>
                ))}
            </div>
        </div>
    </div>
  )
}

export default Hero